export default "__VITE_ASSET__BTueIxEK__"